import { useCartContext } from "app/providers/CartProvider";
import { concatClassnames } from "shared/utils/concatClassnames";
import SendCartOfferModal from "widgets/checkout/send-to-email/SendCartOfferModal";
import VoucherModal from "widgets/shared/add-voucher-modal/VoucherModal";

interface CheckoutFooterLinksProps {
  className?: string;
  setIsVoucherModalOpen: (value: boolean) => void;
}

const CheckoutFooterLinks = ({
  setIsVoucherModalOpen,

  className = "",
}: CheckoutFooterLinksProps) => {
  const { isSampleSale, cartType } = useCartContext();
  return (
    <div
      className={concatClassnames(
        "gg-grid gg-gap-y-2.5 gg-text-yellow gg-underline",
        className,
      )}
    >
      {!isSampleSale && (
        <>
          <VoucherModal orderType={cartType} />

          <SendCartOfferModal />
        </>
      )}
    </div>
  );
};
export default CheckoutFooterLinks;
